import { GapFillabilityEnum } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gapFillabilityEnum";
import { GapPriorityEnum } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gapPriorityEnum";
import { GapTypeEnum } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gapTypeEnum";
import { Badge } from "@app/shared/Badge";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { JSX } from "react";

export const getGapTypeBadge = (gapType: GapTypeEnum): JSX.Element => {
  switch (gapType) {
    case GapTypeEnum.Access:
      return <Badge badgeType="badge--warning">Access</Badge>;
    case GapTypeEnum.Servicing:
      return <Badge badgeType="badge--warning-2">Servicing</Badge>;
    case GapTypeEnum.AccessAndServicing:
      return <><Badge badgeType="badge--warning" className="me-1">Access</Badge><Badge badgeType="badge--warning-2">Servicing</Badge></>;
  }
}

export const getPriorityBadge = (priority: GapPriorityEnum): JSX.Element => {
  const badgeStyle = { fill: "currentColor", fontSize: "8px", verticalAlign: "top" };
  switch (priority) {
    case GapPriorityEnum.Critical:
      return <Badge badgeType="badge--danger"><QesIcon iconName={QesIcons.Circle} isDecorative style={badgeStyle} /> Critical</Badge>;
    case GapPriorityEnum.High:
      return <Badge badgeType="badge--danger"><QesIcon iconName={QesIcons.Circle} isDecorative style={badgeStyle} /> High</Badge>;
    case GapPriorityEnum.Medium:
      return <Badge badgeType="badge--warning"><QesIcon iconName={QesIcons.Circle} isDecorative style={badgeStyle} /> Medium</Badge>;
    case GapPriorityEnum.Low:
      return <Badge badgeType="badge--success"><QesIcon iconName={QesIcons.Circle} isDecorative style={badgeStyle} /> Low</Badge>;
    case GapPriorityEnum.Minimal:
      return <Badge badgeType="badge--info"><QesIcon iconName={QesIcons.Circle} isDecorative style={badgeStyle} /> Minimal</Badge>;
  }
}

export const getFillableBadge = (fillable: GapFillabilityEnum): JSX.Element | null => {
  switch (fillable) {
    case GapFillabilityEnum.Fillable:
    case GapFillabilityEnum.FillableBySingleProvider:
      return <Badge badgeType="badge--success">Fillable</Badge>
    case GapFillabilityEnum.IncreaseInAccessBySingleProvider:
    case GapFillabilityEnum.UnfillableIncreaseInAccess:
      return <Badge badgeType="badge--warning">Partial</Badge>
    case GapFillabilityEnum.UnfillableNoIncreaseInAccess:
      return <Badge badgeType="badge--danger">Unfillable</Badge>
    case GapFillabilityEnum.NoGap:
    default:
      return null;
  }
}
